import * as RegionActionTypes from '../actions/regions';

import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state=initialState.regions, action) => {

    const { payload, type } = action;

    switch(type){
        case RegionActionTypes.LIST_REGIONS:
        case RegionActionTypes.LIST_REGIONS_PENDING:
            return { ...state, filteredRegion: [] }

        case RegionActionTypes.LIST_REGIONS_REJECTED:
            return {...state, ...errorResponseHandler(payload, 'RegionsList') }
        case RegionActionTypes.LIST_REGIONS_FULFILLED:
            return { ...state, filteredRegion: payload.data }

        
        case RegionActionTypes.UPDATE_REGION:
        case RegionActionTypes.UPDATE_REGION_PENDING:
            return { ...state }

        case RegionActionTypes.UPDATE_REGION_REJECTED:
            return {...state, ...errorResponseHandler(payload, 'RegionUpdate') }

        case RegionActionTypes.UPDATE_REGION_FULFILLED:
            let updateRegion=payload.data;
            return Object.assign({}, state, {
                filteredRegion:[
                    updateRegion,
                    ...state.filteredRegion
                ],
                region_updating: false,
                successRegionUpdate: 'Region updated'
            })

            //return { ...state, region_updating: false, successRegionUpdate: 'Region updated' }


        case RegionActionTypes.CREATE_REGION:
        case RegionActionTypes.CREATE_REGION_PENDING:
            return { ...state , ion_creating: true }
        case RegionActionTypes.CREATE_REGION_REJECTED:
            return { ...state,...errorResponseHandler(payload,'RegionCreate'), region_creating: false }
        case RegionActionTypes.CREATE_REGION_FULFILLED:
            let createdRegion=payload.data;
            return Object.assign({}, state,{
                filteredRegion:[
                    createdRegion,
                    ...state.filteredRegion
                ],
                successRegionCreate: "Region Created!",
                region_creating: false
            })

        default:
            return state
    }
}





// WEBPACK FOOTER //
// ./src/reducers/regions.js